/*
 * @Descripttion: 人群选择通用组件--多选--目前只提供给画布用 【这里是以京东云鹿的人群弹窗进行改版，内里所有‘官方人群’，其实都对标了抖音的官方人群】
 * @Author: xutingting
 * @LastEditors: yang chenglin
 */
import React, { useEffect, useState } from 'react';
import { Form, Input, Button, Balloon, Tab, Table, Overlay, Select, NumberPicker, } from '@alifd/next';
import moment from 'moment';
import { store } from '@ice/stark-data';
import LzDialog from '@/components/common/LzDialog';
import LzPagination from '@/components/common/LzPagination';
import LzMsg from '@/components/common/LzMsg';
import { CanvasService, Servlets } from '@/service';
// import useCrowdType from '@/hooks/useCrowdType'
import styles from './index.module.scss';
import ConfirmDialog from '../Dialog/ConfirmDialog';

// 查询参数：人群类型下拉列表
const corwdType = [
  { value: 1, label: '官方标签筛选' },
  // { value: 2, label: '手机号上传' },
  { value: 3, label: '官方推荐人群' },
  // { value: 4, label: '云鹿标签筛选' },
  { value: 5, label: '官方标签筛选（新）' },
  { value: 6, label: '云鹿转官方人群' },
  // { value: 7, label: '订单号生成云鹿人群' },
  { value: 8, label: '订单号生成官方人群' },
  { value: 9, label: '手机号生成官方人群' },
  { value: 10, label: '抖店openid生成官方人群' }
];

const SelectCrowd = (props) => {
  /**
   * @param showDialog 是否显示弹窗 BOOLEAN
   * @param closeDialog 关闭弹窗方法 FUNCTION
   * @param selectCrowd 传所选人群数据给父组件 FUNCTION
   * @param checkedCrowd 已选人群 array
   * @param showPackageListRange 显示人群包数据范围：SHOWALL：显示全部  ONLYNOUSE ：只展示未使用状态人群包
   * @param clearParam 父组件每次关闭或打开改变此布尔值，useEffect监听到变化，清空form参数
   * @param showItem 默认值['1','2','3']，用来标识三个tab展示哪个
   */
  const {
    showDialog,
    closeDialog,
    selectCrowd,
    checkedCrowd,
    showPackageListRange,
    showItem = ['1', '2', '3'],
  } = props;
  // const { crowdTypeList } = useCrowdType();
  const [loading, setLoading] = useState(false);
  const [crowdStrategyList, setCrowdStrategyList] = useState([]); // 官方人群数据源
  const [crowdStrategyCheckedList, setCrowdStrategyCheckedList] = useState([]); // 已选官方人群数据源
  const [formSelectStrategy, setFormSelectStrategy] = useState({
    // 官方人群搜索框存储数据的form表单数据
    crowdName: '', // 人群名称
    type: '', // 人群类型
    minCount: null, // 人群数量范围起
    maxCount: null, // 人群数量范围止
  });
  const [formSelectStrategy1, setFormSelectStrategy1] = useState({
    // 官方人群搜索框提交的form表单数据
    crowdName: '', // 人群名称
    type: '', // 人群类型
    minCount: null, // 人群数量范围起
    maxCount: null, // 人群数量范围止
  });

  const [pageInfoStrategy, setPageInfoStrategy] = useState({
    // 官方人群分页数据
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });
  const strategyOption = [
    // 官方人群-人群类型下拉框
    { label: '全部', value: '' },
    { label: '标签筛选', value: 11 },
    { label: '智能筛选', value: 12 },
    { label: '标签运算', value: 13 },
  ];
  const [strategySelectedKeys, setStrategySelectedKeys] = useState([]); // 官方人群已勾选的
  const { Tooltip } = Balloon;

  /**
   * 官方人群选中的行
   */
  const onStrategyRowChange = (selectedKeys, records) => {
    // console.log('触发勾选',selectedKeys,records);
    // 给勾选的复选框数组赋值
    setStrategySelectedKeys(selectedKeys);
    // 给已选人群-->官方人群数据源数组赋值
    const checkedIds = []; // 现已选的id
    crowdStrategyCheckedList.forEach(item => {
      checkedIds.push(item.id);
    })
    const newIds = []; // 此次勾选的id
    records.forEach(item => {
      newIds.push(item.id);
    })
    newIds.forEach((item, index) => { // 加入之前没有、现在加入的数据
      if (!checkedIds.includes(item)) {
        crowdStrategyCheckedList.push(records[index]);
      }
    })
    checkedIds.forEach((item, index) => { // 删除之前存在、现在删除的数据
      if (!selectedKeys.includes(item)) {
        crowdStrategyCheckedList.forEach((itemRecord, indexRecord) => {
          if (itemRecord.id === item) {
            crowdStrategyCheckedList.splice(indexRecord, 1);
          }
        })
      }
    })
    setCrowdStrategyCheckedList(crowdStrategyCheckedList);
  };

  /**
   * 移除已选中的人群
   */
  const delectCheckedCrowd = (id) => {
    if (strategySelectedKeys.includes(id)) {
      const deleteIndex = strategySelectedKeys.findIndex(item => item === id);
      strategySelectedKeys.splice(deleteIndex, 1);
      crowdStrategyCheckedList.splice(deleteIndex, 1);
      onStrategyRowChange(strategySelectedKeys, crowdStrategyCheckedList);
      searchCrowdstrategysList();
    }
  }

  /**
   * 官方人群翻页方法
   */
  const handlePageSizeChangeStrategy = async (pages = {}) => {
    try {
      setPageInfoStrategy({
        ...pageInfoStrategy,
        ...pages,
      });
      searchCrowdstrategysList(
        {
          pageSize: pages.pageSize,
          pageNo: pages.pageNo,
          ...formSelectStrategy1,
        },
        true
      );
    } catch (e) {
      LzMsg.error(e.message);
    }
  };

  /**
   * 初始化
   */
  useEffect(() => {
    searchCrowdstrategysList(); // 官方人群列表
    // 反显勾选的官方人群
    const checkedStrategyArr = checkedCrowd // .filter(item => item.crowdType === 'INSTANCE');
    const checkedStrategyIdArr = [];
    checkedStrategyArr.forEach(item => {
      checkedStrategyIdArr.push(item.id)
    })
    onStrategyRowChange(checkedStrategyIdArr, checkedStrategyArr);
  }, []);

  useEffect(() => {
    setFormSelectStrategy({
      // 搜索框提交的form表单数据
      crowdName: '', // 人群名称
      type: '', // 人群类型
      minCount: null, // 人群数量范围起
      maxCount: null, // 人群数量范围止
    });
  }, [props.clearParam]);

  /**
   * 初始化官方人群列表
   */
  const searchCrowdstrategysList = (v, isPageChange) => {
    if (
      formSelectStrategy.minCount &&
      formSelectStrategy.maxCount &&
      formSelectStrategy.maxCount <= formSelectStrategy.minCount
    ) {
      LzMsg.error('人群数量最大值不应小于人群数量最小值');
      return false;
    }
    setLoading(true);
    const typeValue = v?.type || formSelectStrategy.type || '1,3,5,6,8,9,10';
    const params = {
      crowdStatus: 1, // 0不可用，1可用，2生成中，3已过期
      pageNo: pageInfoStrategy.pageNo,
      pageSize: pageInfoStrategy.pageSize,
      ...formSelectStrategy,
      ...v,
      type: typeValue, // 人群类型
    };
    // Servlets.crowdstrategysList(isPageChange === true ? v : params)
    //   .then((res) => {
    //     res.data.forEach(item => {
    //       item['crowdType'] = 'INSTANCE'
    //     })
    //     setCrowdStrategyList(res.data);
    //     if (res.page) {
    //       for (const key in res.page) {
    //         if (key == 'pageNo') {
    //           res.page.pageNo = res.page[key];
    //         }
    //       }
    //       setPageInfoStrategy(res.page);
    //     } else {
    //       setPageInfoStrategy(pageInfoStrategy);
    //     }
    //     setLoading(false);
    //   })
    //   .catch((e) => {
    //     LzMsg.error('请求失败，请稍后重试');
    //     setLoading(false);
    //   });

      Servlets('getDYCrowdList', params).then((res) => {
        if (res.success) {
          res.data.forEach(item => {
            item['crowdType'] = 'instance'
          })
          setCrowdStrategyList(res.data);
          setLoading(false);
          setPageInfoStrategy({
            ...pageInfoStrategy,
            pageNo: res.page.pageNo,
            pageSize: res.page.pageSize,
            total: res.page.total,
          });
        } else {
          setLoading(false);
          LzMsg.error(res.resp_msg);
        }
      });
  };

  /**
   * 人群总数量列 此时接口返回的数据还没有lastTotal TODO
   */
  const crowdTotalRender = (value, index, item) => {
    return (
      <div>
        <span>{item.total ? item.total : '-'}</span>
        <br />
        {/* {calculation(item.total,item.lastTotal)} */}
      </div>
    );
  };

  /**
   * 关闭弹窗
   */
  const handleCancel = () => {
    closeDialog();
    setFormSelectStrategy({
      // 搜索框提交的form表单数据
      crowdName: '', // 人群名称
      type: '', // 人群类型
      minCount: null, // 人群数量范围起
      maxCount: null, // 人群数量范围止
    });
  };

  // 官方人群的重置
  const strategyRest = () => {
    setFormSelectStrategy1({
      crowdName: '',
      type: '',
      minCount: null,
      maxCount: null,
    });
    setFormSelectStrategy({
      crowdName: '',
      type: '',
      minCount: null,
      maxCount: null,
    });
    searchCrowdstrategysList({
      pageNo: 1,
      crowdName: '',
      minCount: '',
      maxCount: '',
      type: '1,3,5,6,8,9,10',
    });
  };

  /**
   * 重置
   * type:1 官方人群 type:2 人群包 type:3 重点人群 type:4 人群分组
   */
  const handleReset = (type) => {
    strategyRest();
  };
  /**
   * 确认选择
   */
  const confirm = () => {
    if ([...crowdStrategyCheckedList].length > 30) {
      LzMsg.error('最多选择30条');
    } else {
      selectCrowd([...crowdStrategyCheckedList]);
      closeDialog();
    }
  }

  /**
   * 取消选择
   */
  const cancel = () => {
    closeDialog();
  }
  /**
     * 使用标签列
     */
  const labelsDescriptionRender = (value, index, item) => {
    return (<>
      {
        item.useLabelDescription
          ?
          (
            <Balloon
              align="t"
              closable={false}
              style={{ color: '#9ca7b6', paddingLeft: '5px' }}
              align="rb"
              trigger={
                <div>
                  <div style={{
                    width: '100px',
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                  }}
                  >
                    {item.useLabelDescription}
                  </div>
                </div>
              }
            >
              <div style={{ padding: '0px 0px 10px 10px', textAlign: 'justify', color: '#9ca7b6' }}>
                {item.useLabelDescription}
              </div>
            </Balloon>
          )
          :
          '/'
      }
    </>);
  };


  const [currentTab, setCurrentTab] = useState('1'); // tab默认值，为新建后回来的刷新
  const [tabForTips, setTabForTips] = useState('1'); // tab默认值，为新建后回来的刷新

  return (
    <div>
      <LzDialog
        title="选择人群"
        footer={false}
        isFullScreen
        visible={showDialog}
        onClose={handleCancel}
        shouldUpdatePosition
        style={{ width: 1060 }}
      >
        <div>
          <div className="select-crowd">
            <Tab
              shape="wrapped"
              style={{ padding: '30px 30px 15px 30px' }}
              activeKey={currentTab}
              onClick={(tab) => {
                setCurrentTab(tab);
              }}
            >
              {showItem.indexOf('1') > -1 && (
                <Tab.Item title="人群列表" key="1">
                  <Form inline style={{ marginTop: '20px' }}>
                    <Form.Item label="人群名称：">
                      <Input
                        trim
                        style={{ width: '200px' }}
                        className="formItemWidth"
                        name="crowdName"
                        placeholder="请输入人群名称"
                        size="small"
                        value={formSelectStrategy.crowdName}
                        onChange={(v) =>
                          setFormSelectStrategy({
                            ...formSelectStrategy,
                            crowdName: v,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item label="人群类型：">
                      <Select
                        style={{ width: '200px' }}
                        //   followTrigger
                        dataSource={corwdType}
                        value={formSelectStrategy.type}
                        onChange={(v) =>
                          setFormSelectStrategy({
                            ...formSelectStrategy,
                            type: v,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item label="人群数量：">
                      <NumberPicker
                        min={0}
                        hasTrigger={false}
                        style={{ width: '50px' }}
                        className={`formItemWidth ${styles.mr10}`}
                        name="minCount"
                        size="small"
                        value={formSelectStrategy.minCount}
                        onChange={(v) =>
                          setFormSelectStrategy({
                            ...formSelectStrategy,
                            minCount: v,
                          })
                        }
                      />
                      <span className={`${styles.mr10}`}>-</span>
                      <NumberPicker
                        min={0}
                        hasTrigger={false}
                        style={{ width: '50px' }}
                        className="formItemWidth"
                        name="maxCount"
                        size="small"
                        value={formSelectStrategy.maxCount}
                        onChange={(v) =>
                          setFormSelectStrategy({
                            ...formSelectStrategy,
                            maxCount: v,
                          })
                        }
                      />
                    </Form.Item>
                    <Form.Item>
                      <Button
                        type="primary"
                        className={`${styles.mr10} ${styles.w88}`}
                        onClick={() => {
                          setFormSelectStrategy1(formSelectStrategy);
                          searchCrowdstrategysList({ pageNo: 1 });
                        }}
                      >
                        查询
                      </Button>
                      <Button
                        type="normal"
                        className={styles.w88}
                        onClick={() => {
                          handleReset(1);
                        }}
                      >
                        重置
                      </Button>
                    </Form.Item>
                  </Form>
                  <Table
                    loading={loading}
                    dataSource={crowdStrategyList}
                    fixedHeader
                    maxBodyHeight={
                      document.documentElement.clientHeight * 0.7 - 190
                    }
                    rowSelection={{
                      selectedRowKeys: strategySelectedKeys,
                      onChange: onStrategyRowChange,
                    }}
                    className={styles['crowd-table']}
                  >
                    <Table.Column
                      title="人群名称"
                      align="left"
                      dataIndex="name"
                      width="194"
                    />
                    <Table.Column
                      title="人群描述"
                      align="left"
                      dataIndex="description"
                      width="194"
                    />
                    <Table.Column
                      title="人群类型"
                      align="left"
                      cell={(value, index, record) => (
                        <span>{corwdType.find((item) => item.value === record.type)?.label}</span>
                      )}
                      width="194"
                    />
                    <Table.Column
                      title="使用标签"
                      align="left"
                      cell={labelsDescriptionRender}
                      width="194"
                    />
                    <Table.Column
                      title="人群总数量"
                      align="left"
                      cell={(value, index, record) => (
                        <span>{record.size.toLocaleString()}</span>
                      )}
                      width="194"
                    />
                    <Table.Column
                      title="创建时间"
                      align="left"
                      cell={(value, index, record) => (
                        <span>{moment(record.createTime).format('YYYY-MM-DD HH:mm:ss')}</span>
                      )}
                      width="194"
                    />
                    <Table.Column
                      title="状态"
                      align="left"
                      cell={(value, index, record) => (
                        <span>{record.crowdStatus === 1 ? '可用' : '不可用'}</span>
                      )}
                      width="194"
                    />
                    <Table.Column
                      title="已使用次数"
                      align="left"
                      cell={(value, index, record) => (
                        <span>{record.useCount.toLocaleString()}</span>
                      )}
                      width="194"
                    />
                    <Table.Column
                      align="center"
                      title="操作"
                      width={121}
                      cell={(value, index, item) => {
                        return (
                          <div>
                            {!strategySelectedKeys.includes(item.id) && <Button
                              type="primary"
                              text
                              onClick={() => {
                                onStrategyRowChange([...strategySelectedKeys, item.id], [...crowdStrategyCheckedList, item])
                              }}
                            >
                              选择
                            </Button>}
                            {strategySelectedKeys.includes(item.id) &&
                              <span style={{ color: '#333' }}>已选择</span>
                            }
                          </div>
                        );
                      }}
                    />
                  </Table>
                  <LzPagination
                    pageInfo={pageInfoStrategy}
                    onChange={handlePageSizeChangeStrategy}
                  />
                </Tab.Item>
              )}
              {// 进入人群分组tab不展示已选人群
                +currentTab !== 4 &&
                <Tab.Item title={`已选人群(${[...crowdStrategyCheckedList].length})`} key="5">
                  <Table
                    style={{ marginTop: '30px' }}
                    loading={loading}
                    dataSource={[...crowdStrategyCheckedList]}
                    fixedHeader
                    maxBodyHeight={
                      document.documentElement.clientHeight * 0.7 - 190
                    }
                    className={styles['crowd-table']}
                  >
                    <Table.Column
                      title="人群名称"
                      align="left"
                      dataIndex="name"
                      width="194"
                    />
                    <Table.Column
                      title="人群描述"
                      align="left"
                      dataIndex="description"
                      width="194"
                    />
                    <Table.Column
                      title="人群类型"
                      align="left"
                      cell={(value, index, record) => (
                        <span>{corwdType.find((item) => item.value === record.type)?.label}</span>
                      )}
                      width="194"
                    />
                    <Table.Column
                      title="使用标签"
                      align="left"
                      cell={labelsDescriptionRender}
                      width="194"
                    />
                    <Table.Column
                      title="人群总数量"
                      align="left"
                      cell={(value, index, record) => (
                        <span>{record.size.toLocaleString()}</span>
                      )}
                      width="194"
                    />
                    <Table.Column
                      title="创建时间"
                      align="left"
                      cell={(value, index, record) => (
                        <span>{moment(record.createTime).format('YYYY-MM-DD HH:mm:ss')}</span>
                      )}
                      width="194"
                    />
                    <Table.Column
                      title="状态"
                      align="left"
                      cell={(value, index, record) => (
                        <span>{record.crowdStatus === 1 ? '可用' : '不可用'}</span>
                      )}
                      width="194"
                    />
                    <Table.Column
                      title="已使用次数"
                      align="left"
                      cell={(value, index, record) => (
                        <span>{record.useCount.toLocaleString()}</span>
                      )}
                      width="194"
                    />
                    <Table.Column
                      align="center"
                      title="操作"
                      width={120}
                      cell={(value, index, item) => {
                        return (
                          <div>
                            <Button
                              type="primary"
                              text
                              onClick={() => {
                                delectCheckedCrowd(item.id);
                              }}
                            >
                              删除
                            </Button>
                          </div>
                        );
                      }}
                    />
                  </Table>
                  {/* <LzPagination
                  pageInfo={pageInfoImportant}
                  onChange={handlePageSizeChangeImportant}
                /> */}
                </Tab.Item>
              }
            </Tab>
          </div>
          <hr />
          <div style={{ padding: '15px 30px 0 0', height: '60px' }}>
            <Button
              type="primary"
              className={`submit-btn ${styles.w88}`}
              onClick={confirm}
              style={{ float: 'right' }}
            >
              确认
            </Button>
            <Button
              type="normal"
              className={`cancel-btn ${styles.mr10} ${styles.w88}`}
              onClick={cancel}
              style={{ float: 'right' }}
            >
              取消
            </Button>
          </div>
        </div>
      </LzDialog>
    </div>
  );
};

export default SelectCrowd;
